export default {"src":"/_next/static/media/tree-single.1376e9fc.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};